export default {
    root: ({ props, context, parent, instance }) => ({
        class: [['input-otp-root']],
    }),
};
